<template>
  <v-content class="mx-4">
    <!--Menu Nevigation-->
    <!--if tap = 1-->
    <v-layout v-if="tab == 1">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">ข้อมูลคุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์</span>
        </v-btn>
        <v-icon style="color: #527281">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #527281">อุปกรณ์สายแพทย์ทั้งหมด</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!--if tap = 2-->
    <v-layout v-if="tab == 2">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">ข้อมูลคุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์</span>
        </v-btn>
        <v-icon style="color: #527281">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #527281">ข้อมูลกลุ่มหลัก สป.</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!--if tap = 3-->
    <v-layout v-if="tab == 3">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">ข้อมูลคุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์</span>
        </v-btn>
        <v-icon style="color: #527281">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #527281">นำเข้าอุปกรณ์ สป. ด้วยไฟล์ Excel</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!--Menu Bar-->
    <v-layout class="button-taps">
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 1" :class="{active: tab === 1}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          อุปกรณ์สายแพทย์ทั้งหมด
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 2" :class="{active: tab === 2}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          ข้อมูลกลุ่มหลัก สป.
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 3" :class="{active: tab === 3}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          นำเข้าอุปกรณ์ สป. ด้วยไฟล์ Excel
        </v-btn>
      </v-flex>

      <!--Button Add Medical Tools-->
      <v-flex style="text-align: right;position: absolute;top:45px;right:0px;">
        <v-btn v-if="tab == 1" class="mr-1" color="#84A2A8"
               @click="$router.push('/add-data-tool').catch(err => {})"
               style="color: white;border-radius: 50px;text-align: right;">
          <v-icon dark>add</v-icon>
          เพิ่ม/สร้างข้อมูล
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Tap Tools -->
    <template v-if="tab == 1">
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;">
          <v-layout>
            <v-flex shrink mr-4>
              <span style="font-size: 24px;font-weight: bold;">ค้นหาข้อมูล : </span>
            </v-flex>
            <v-flex xs2 mt-1 mr-2 class="search-Data-Form">
              <v-select
                class="custom-placeholer-color"
                hide-details
                :menu-props="{ bottom: true, offsetY: true }"
                :items="optionMainGroupSearchTools"
                item-text="option_select_main_group"
                item-value="group_num"
                v-model="dataSearchMainGroup"
                label="กลุ่มหลัก สป."
                @change="getSearchSubGroup"
                color="#ffffff"
                single-line
                outlined
                clearable
                dark
              ></v-select>
            </v-flex>
            <v-flex xs2 mt-1 mr-2 class="search-Data-Form">
              <v-select
                class="custom-placeholer-color"
                hide-details
                :menu-props="{ bottom: true, offsetY: true }"
                :items="optionSubGroupSearchTools"
                item-text="option_select_sub_group"
                item-value="group_num"
                v-model="dataSearchSubGroup"
                label="กลุ่มย่อย สป."
                color="#ffffff"
                single-line
                clearable
                outlined
                dark
              ></v-select>
            </v-flex>
            <v-flex xs2 mt-1 class="search-Data-Form">
              <v-text-field
                class="custom-placeholer-color"
                hide-details
                v-model="dataSearchSpecNo"
                placeholder="เลขที่ สป."
                color="#ffffff"
                single-line
                outlined
                dark
              ></v-text-field>
            </v-flex>
            <v-flex shrink ml-4 mr-2>
              <v-btn rounded @click="searchTool()">
                ค้นหา
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout justify-center class="table-search">
        <v-flex>
          <v-card>
            <template>
              <v-data-table
                :headers="headerTools"
                :items="dataTools"
                :hide-default-footer="true"
              >
                <template v-slot:item.nameSpTH="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.nameSpTH}}
                  </v-flex>
                </template>
                <template v-slot:item.nameSpEng="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.nameSpEng}}
                  </v-flex>
                </template>
                <template v-slot:item.mainTool="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.mainTool}}
                  </v-flex>
                </template>
                <template v-slot:item.viewdata="{ item }">
                  <v-icon style="color: #D97C57;cursor: pointer;" @click="viewDataTool(item.id)">search</v-icon>
                </template>
                <template v-slot:item.printSupply="{ item }">
                  <v-icon style="color: #D97C57;cursor: pointer;">attach_file</v-icon>
                </template>
                <template v-slot:item.printView="{ item }">
                  <v-icon style="color: #D97C57;cursor: pointer;">attach_file</v-icon>
                </template>
                <template v-slot:item.modify="{ item }">
                  <span style="text-decoration: underline;color: #D97C57;cursor: pointer;"
                        @click="onEditTool(item.id)">แก้ไข/ลบ</span>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
      <v-flex mt-4>
        <v-pagination
          :length="pagination.last_page"
          :total-visible="9"
          @input="getPagination"
          v-model="pagination.current_page"
        ></v-pagination>
      </v-flex>
    </template>

    <!-- View Data -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="700px">
          <v-card>
            <v-card-title>
              <span style="font-weight: bold">รายละเอียดอุปกรณ์การเเพทย์</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-flex xs12 class="dialog-detail">

                  <v-layout>
                    <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                      เลขที่ สป.​ :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.spec_no"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                      หมายเลข สป. :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.spec_code"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                      ชื่อ สป. (ไทย) :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.name_th"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                      ชื่อ สป. (อังกฤษ) :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.name_en"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      หน่วยนับ :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.unit"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      ปีที่จัดทำ :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.year"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      Commld :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.comm_id"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      ประเภท :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.type_spec"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      สถานะอุปกรณ์ :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.status"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      Pass_No :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.pass_no"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      DepName :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.dep_name"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      Group Num :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.group_num"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      Main Group :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.main_group"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      Sub Group :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.sub_group"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      Workername :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.workername"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      Keyword :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.keyword"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                      GPSC  :
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="form.gpsc"
                        background-color="#E5E5E5"
                        value=""
                        item-color="#84A2A8"
                        solo
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-layout class="mb-4" justify-center>
                <v-flex shrink class="ma-2">
                  <v-btn style="background-color: #BDBDBD; color: white;border-radius: 25px;" @click="dialog = false">ย้อนกลับ</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Tap Main Group Data -->
    <template v-if="tab == 2">
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;" class="tab-2">
          <v-layout>
            <v-flex shrink mr-4>
              <span style="font-size: 24px;font-weight: bold;">ค้นหากลุ่มหลัก: </span>
            </v-flex>
            <v-flex xs6 mt-1 class="search-Data-Form">
              <v-select style="text-align: left"
                class="custom-placeholer-color"
                hide-details
                v-model="selectedGroup"
                :menu-props="{ bottom: true, offsetY: true }"
                :items="optionMainGroupSearchTools"
                item-text="option_select_main_group"
                item-value="group_main"
                @change="getSearchGroup"
                label="ค้นหา"
                color="#ffffff"
                single-line
                outlined
                dark
              ></v-select>
            </v-flex>
            <v-flex ml-3 shrink>
              <v-btn style="background-color: #ffffff" rounded @click="getMainGroup">
                ทั้งหมด
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout justify-center>
        <v-flex>
          <div style="width: 100%; overflow: auto;">
            <v-card outlined>
              <v-data-table
                :headers="headerSearchDataTool"
                :items="optionSpec"
                :hide-default-footer="true"
              >
                <template v-slot:item.subGroup1="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.subGroup1}}
                  </v-flex>
                </template>
                <template v-slot:item.subGroup2="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.subGroup2}}
                  </v-flex>
                </template>
                <template v-slot:item.subGroup3="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.subGroup3}}
                  </v-flex>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
      <v-flex mt-4>
        <v-pagination
          :length="paginationSpec.last_page"
          :total-visible="9"
          @input="getPaginationSpec"
          v-model="paginationSpec.current_page"
        ></v-pagination>
      </v-flex>
    </template>

    <!-- Tap Main Import Data Tool -->
    <template v-if="tab == 3">
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;">
          <v-layout>
            <v-flex shrink mr-4>
              <span style="font-size: 24px;font-weight: bold;">เลือกไฟล์: </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout class="tab-import-tool">
        <v-flex>
          <v-card class="pt-6">
            <div class="form-group" v-for="(input,k) in inputs" :key="k">
              <v-layout px-6>
                <v-flex>
                  <v-layout pb-4 justify-center>
                    <v-flex shrink pt-2>
                      <span style="color: #527281;font-weight: bold;">แนบเอกสาร : </span>
                    </v-flex>
                    <v-flex mr-4>
                      <loading :active.sync="isLoading"
                               :can-cancel="false"
                               color="#527281"
                               :is-full-page="fullPage">
                      </loading>
                      <v-file-input
                        label="File input"
                        v-model="input.import_file"
                        outlined
                        type="file"
                        dense
                        solo
                        flat
                        hide-details
                      ></v-file-input>
                    </v-flex>
                    <v-flex shrink>
                      <v-btn style="background-color: #D97C57; color: white;"
                             @click="remove(k)"
                             v-if="k != inputs.length-1"
                      >
                        <v-icon>remove</v-icon>
                        <span>ลบไฟล์</span>
                      </v-btn>
                      <v-btn style="color: #527281;"
                             @click="add(k)"
                             v-if="k == inputs.length-1"
                      >
                        <v-icon>add</v-icon>
                        <span>เพิ่มไฟล์</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout mb-4>
                    <v-flex>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout justify-center mt-6>
        <v-flex>
          <v-btn
            color="#527281"
            class="mr-4"
            @click="importDataToolsExcel()"
          >
            <span style="color: white;">นำเข้าอุปกรณ์ {{inputs.length}} ไฟล์</span>
          </v-btn>
        </v-flex>
      </v-layout>

    </template>



  </v-content>
</template>

<script>
    import Service from '../service'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        // name: "DataMedicalEquipment",
        components: {
            Loading
        },
        data: () => ({
            group_id: null,
            form: {
                spec_no: '',
                spec_code: '',
                name_th: '',
                name_en: '',
                unit: '',
                year: '',
                comm_id: '',
                path_file: [],
                type_spec: '',
                status: '',
                pass_no: '',
                dep_name: '',
                group_num: '',
                main_group:'',
                sub_group:'',
                gpsc: '',
                workername: '',
                keyword: '',
            },
            dialog: false,
            selectFileData: '',
            inputFormImport: '',
            inputs: [
                {import_file: null},
            ],
            import_file: [],
            tab: 1,
            selectedGroup: null,
            //Data Tools
            dataSearchMainGroup:'',
            dataSearchSubGroup:'',
            dataSearchSpecNo:'',
            headerTools: [
                {text: 'เลขที่ สป.', value: 'idSp', sortable: true, align: 'center',},
                {text: 'หมายเลข สป.', value: 'noSp', sortable: true, align: 'center',},
                {text: 'ชื่อ สป. (ไทย)', value: 'nameSpTH', sortable: true, align: 'center',},
                {text: 'ชื่อ สป. (อังกฤษ)', value: 'nameSpEng', sortable: true, align: 'center',},
                {text: 'กลุ่มหลักสิ่งอุปกรณ์', value: 'mainTool', sortable: true, align: 'center',},
                {text: 'อุปกรณ์กลุ่มย่อยของอุปกรณ์', value: 'subTool', sortable: true, align: 'center',},
                {text: 'ปีที่จัดทำ', value: 'years', sortable: true, align: 'center',},
                {text: 'ประเภท', value: 'type', sortable: true, align: 'center',},
                {text: 'GPSC', value: 'gpsc', sortable: true, align: 'center',},
                {text: 'Update', value: 'update', sortable: true, align: 'center',},
                {text: 'สถานะอุปกรณ์', value: 'status', sortable: true, align: 'center',},
                {text: 'ดูข้อมูล', value: 'viewdata', sortable: true, align: 'center',},
                {text: 'สั่งพิมพ์เพื่อจัดหา', value: 'printSupply', sortable: true, align: 'center',},
                {text: 'สั่งพิมพ์เพื่อดู', value: 'printView', sortable: true, align: 'center',},
                {text: 'ปรับปรุง ', value: 'modify', sortable: true, align: 'center',}
            ],
            dataTools: [],
            optionMainGroupSearchTools: [],
            optionSubGroupSearchTools: [],

            //Header Group Data Search
            optionSpec: [],
            headerSearchDataTool: [
                {text: 'กลุ่ม สป.', value: 'groupSp', sortable: true, align: 'center',},
                {text: 'กลุ่มย่อย 1', value: 'subGroup1', sortable: true, align: 'center',},
                {text: 'กลุ่มย่อย 2', value: 'subGroup2', sortable: true, align: 'center',},
                {text: 'กลุ่มย่อย 3', value: 'subGroup3', sortable: true, align: 'center',},
            ],
            showDataSearchDataToolGroup: [],

            // Loading When Import
            isLoading: false,
            fullPage: false,

            // Pagination
            pagination: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            paginationSpec: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
        }),
        created() {
            if (this.$route.query.activeTab !== undefined) {
                this.tab = this.$route.query.activeTab;
            }
            this.getAllDataTool();
            this.getMainGroup();
            this.getSearchMainGroup();
        },
        methods: {

            // Data Tools ****************************************
            getAllDataTool() {
              Service.MedicalTool.getAllDataTool(this.pagination.current_page).then(data => {
                  let tools = data.data;
                  // console.log(data)
                  tools.forEach(specTool => {
                      this.dataTools.push({
                          id: specTool.id,
                          idSp: specTool.spec_no === null ? '-' : specTool.spec_no,
                          noSp: specTool.spec_code === null ? '-' : specTool.spec_code,
                          nameSpTH: specTool.name_th === null ? '-' : specTool.name_th,
                          nameSpEng: specTool.name_en === null ? '-' : specTool.nCame_en,
                          mainTool: specTool.spec_group_.main_group_desc === null ? '-' : specTool.spec_group_.main_group_desc,
                          subTool: specTool.spec_group_.sub_group2_desc === null ? '-' : specTool.spec_group_.sub_group2_desc,
                          years: specTool.year === null ? '-' : specTool.year,
                          type: specTool.type_spec === null ? '-' : specTool.type_spec,
                          gpsc: specTool.gpsc === null ? '-' : specTool.gpsc,
                          update: specTool.updated_at === null ? 'ไม่ทราบ' : specTool.updated_at,
                          status: specTool.status === '1' ? 'ใช้งาน' : specTool.status === '2' ? 'รอยกเลิก' : 'ยกเลิก',
                      });
                  })

                  this.pagination.current_page = data.current_page;
                  this.pagination.from = data.from;
                  this.pagination.last_page = data.last_page;
                  this.pagination.per_page = data.per_page;
                  this.pagination.total = data.total;
                  this.pagination.to = data.to;
              })
            },

            onEditTool(id) {
                this.$router.push(`/edit-and-delete-tool/${id}`).catch(err => {});
            },
            add(index) {
                this.inputs.push({name: null});
            },
            remove(index) {
                this.inputs.splice(index, 1);
            },
            importDataToolsExcel() {
                confirm("คุณต้องการนำเข้าไฟล์ทั้งหมด : " + this.inputs.length + "ไฟล์");
                this.isLoading = true;
                let dataList = [];
                for (let i = 0; i < this.inputs.length; i++) {
                    dataList.push(this.inputs[i]);
                    Service.MedicalTool.importDataToolsExcel({
                        import_file : this.inputs[i].import_file,
                    }).then(data => {
                        setTimeout(() => {
                            this.isLoading = false
                        })
                        alert('นำเข้าไฟล์เรียบร้อยแล้ว')
                        console.log('Import Success.....',i)
                    })
                }
            },
            viewDataTool(id) {
                this.dialog = true;
                // console.log(id)
                let result = Service.MedicalTool.getDataToolEdit(id).then(data => {
                    // console.log(data)
                    this.form.spec_no = data.spec_no;
                    this.form.spec_code = data.spec_code;
                    this.form.name_th = data.name_th;
                    this.form.name_en = data.name_en;
                    this.form.unit = data.unit;
                    this.form.year = data.year;
                    this.form.comm_id = data.comm_id;
                    this.form.path_file = [data.path_file];
                    this.form.type_spec = data.type_spec;
                    this.form.status = data.status === "1" ? "ใช้งาน" : "ยกเลิก";
                    this.form.pass_no = data.pass_no;
                    this.form.dep_name = data.dep_name;
                    this.form.group_num = data.spec_group.main_group_desc;
                    this.form.gpsc = data.gpsc;
                    this.form.workername = data.workername;
                    this.form.keyword = data.keyword;
                })

                if(result) {
                    console.log('Success');
                }else {
                    console.log('Failed')
                }
            },

            //Data Spec Group ****************************************
            getMainGroup() {
                this.optionSpec = [];
                Service.SpecGroup.getMainGroup(this.pagination.current_page).then(res => {
                    // console.log(res)
                    res.data.forEach(mainGroup => {
                        this.optionSpec.push({
                            optionSelect: `หมวดหมู่ ${mainGroup.group_main} ${mainGroup.main_group_desc}`,
                            group_main: `${mainGroup.group_main}`,
                            groupNum: `${mainGroup.group_num}`,
                            groupSp: `${mainGroup.group_num}`,
                            subGroup1: mainGroup.sub_group1_desc === null ? '-' : mainGroup.sub_group1_desc,
                            // subGroup1: mainGroup.group_level === "1" ? mainGroup.main_group_desc : mainGroup.sub_group1_desc,
                            subGroup2: mainGroup.sub_group2_desc === null ? '-' : mainGroup.sub_group2_desc,
                            subGroup3: mainGroup.sub_group3_desc === null ? '-' : mainGroup.sub_group3_desc,
                        });
                    })

                    this.paginationSpec.current_page = res.current_page;
                    this.paginationSpec.from = res.from;
                    this.paginationSpec.last_page = res.last_page;
                    this.paginationSpec.per_page = res.per_page;
                    this.paginationSpec.total = res.total;
                    this.paginationSpec.to = res.to;

                    // console.log('paginate', this.paginationSpec)
                })
            },

            // Search Tools
            searchTool() {
                let data = {
                    main_group: this.dataSearchMainGroup,
                    sub_group: this.dataSearchSubGroup,
                    spec_no: this.dataSearchSpecNo,
                    page: this.pagination.current_page,
                }
                // console.log(data)
                this.dataTools = [];
                Service.MedicalTool.searchMed(data).then(data => {
                    // console.log(data)
                    data.data.forEach(specTool => {
                        this.dataTools.push({
                            id: specTool.id,
                            idSp: specTool.spec_no === null ? '-' : specTool.spec_no,
                            noSp: specTool.spec_code === null ? '-' : specTool.spec_code,
                            nameSpTH: specTool.name_th === null ? '-' : specTool.name_th,
                            nameSpEng: specTool.name_en === null ? '-' : specTool.name_en,
                            mainTool: '-',
                            subTool: '-',
                            years: specTool.year === null ? '-' : specTool.year,
                            type: specTool.type_spec === null ? '-' : specTool.type_spec,
                            gpsc: specTool.gpsc === null ? '-' : specTool.gpsc,
                            update: specTool.updated_at === null ? 'ไม่ทราบ' : specTool.updated_at,
                            status: specTool.status === '1' ? 'ใช้งาน' : 'ยกเลิก',
                            // status: specTool.status === '1' ? 'ใช้งาน' : specTool.status === '2' ? 'รอยกเลิก' : 'ยกเลิก',
                        });
                    })
                    this.pagination.current_page = data.current_page;
                    this.pagination.from = data.from;
                    this.pagination.last_page = data.last_page;
                    this.pagination.per_page = data.per_page;
                    this.pagination.total = data.total;
                    this.pagination.to = data.to;
                    // console.log(this.pagination)
                })
            },
            getSearchMainGroup() {
                Service.SpecGroup.getSearchMainGroup().then(data => {
                    // console.log(data)
                    data.forEach(mainGroup => {
                        this.optionMainGroupSearchTools.push({
                            option_select_main_group:  `หมวดหมู่ ${mainGroup.group_main} ${mainGroup.main_group_desc}`,
                            group_num: `${mainGroup.group_num}`,
                            group_main: `${mainGroup.group_main}`
                        });
                    })
                })
            },
            getSearchSubGroup(id) {
                // console.log(id)
                this.optionSubGroupSearchTools = [];
                Service.SpecGroup.getSubGroup(id).then(data => {
                    // console.log(data)
                    data.forEach(mainGroup => {
                        this.optionSubGroupSearchTools.push({
                            option_select_sub_group:  `${mainGroup.sub_group1_desc}`,
                            group_num: `${mainGroup.sub_group1}`,
                        });
                    })
                })
            },

            // Search Group
            getSearchGroup(id) {
                this.group_id = id;
                let data = { id: id, page: 1, }
                this.optionSpec = [];
                this.paginationSpec.current_page = 1;
                this.paginationSpec.from = 1;
                this.paginationSpec.last_page = 1;
                this.paginationSpec.per_page = 1;
                this.paginationSpec.total = 1;
                this.paginationSpec.to = 1;

                Service.SpecGroup.getSearchGroup(data).then(res => {
                    // console.log(res)
                    res.data.forEach(mainGroup => {
                        this.optionSpec.push({
                            optionSelect: `หมวดหมู่ ${mainGroup.group_main} ${mainGroup.main_group_desc}`,
                            group_main: `${mainGroup.group_main}`,
                            groupNum: `${mainGroup.group_num}`,
                            groupSp: `${mainGroup.group_num}`,
                            subGroup1: mainGroup.sub_group1_desc === null ? '-' : mainGroup.sub_group1_desc,
                            subGroup2: mainGroup.sub_group2_desc === null ? '-' : mainGroup.sub_group2_desc,
                            subGroup3: mainGroup.sub_group3_desc === null ? '-' : mainGroup.sub_group3_desc,
                        });
                    })
                    this.paginationSpec.current_page = res.current_page;
                    this.paginationSpec.from = res.from;
                    this.paginationSpec.last_page = res.last_page;
                    this.paginationSpec.per_page = res.per_page;
                    this.paginationSpec.total = res.total;
                    this.paginationSpec.to = res.to;
                })
            },

            // Pagination
            getPagination(page) {
                // console.log(page)
                this.dataTools = [];
                Service.MedicalTool.getAllDataTool(page).then(data => {
                    let tools = data.data;
                    tools.forEach(specTool => {
                            this.dataTools.push({
                                id: specTool.id,
                                idSp: specTool.spec_no === null ? '-' : specTool.spec_no,
                                noSp: specTool.spec_code === null ? '-' : specTool.spec_code,
                                nameSpTH: specTool.name_th === null ? '-' : specTool.name_th,
                                nameSpEng: specTool.name_en === null ? '-' : specTool.nCame_en,
                                mainTool: specTool.spec_group_.main_group_desc === null ? '-' : specTool.spec_group_.main_group_desc,
                                subTool: specTool.spec_group_.sub_group2_desc === null ? '-' : specTool.spec_group_.sub_group2_desc,
                                years: specTool.year === null ? '-' : specTool.year,
                                type: specTool.type_spec === null ? '-' : specTool.type_spec,
                                gpsc: specTool.gpsc === null ? '-' : specTool.gpsc,
                                update: specTool.updated_at === null ? 'ไม่ทราบ' : specTool.updated_at,
                                status: specTool.status === '1' ? 'ใช้งาน' : specTool.status === '2' ? 'รอยกเลิก' : 'ยกเลิก',
                            });
                    })

                    this.pagination.current_page = data.current_page;
                    this.pagination.from = data.from;
                    this.pagination.last_page = data.last_page;
                    this.pagination.per_page = data.per_page;
                    this.pagination.total = data.total;
                    this.pagination.to = data.to;
                    // console.log(this.pagination)
                })
            },
            getPaginationSpec(page) {
                let id = this.group_id;
                if (id === null) {
                    this.optionSpec = [];
                    Service.SpecGroup.getMainGroup(page).then(res => {
                        // console.log(res)
                        res.data.forEach(mainGroup => {
                            this.optionSpec.push({
                                optionSelect: `หมวดหมู่ ${mainGroup.group_main} ${mainGroup.main_group_desc}`,
                                group_main: `${mainGroup.group_main}`,
                                groupNum: `${mainGroup.group_num}`,
                                groupSp: `${mainGroup.group_num}`,
                                subGroup1: mainGroup.sub_group1_desc === null ? '-' : mainGroup.sub_group1_desc,
                                // subGroup1: mainGroup.group_level === "1" ? mainGroup.main_group_desc : mainGroup.sub_group1_desc,
                                subGroup2: mainGroup.sub_group2_desc === null ? '-' : mainGroup.sub_group2_desc,
                                subGroup3: mainGroup.sub_group3_desc === null ? '-' : mainGroup.sub_group3_desc,
                            });
                        })

                        this.paginationSpec.current_page = res.current_page;
                        this.paginationSpec.from = res.from;
                        this.paginationSpec.last_page = res.last_page;
                        this.paginationSpec.per_page = res.per_page;
                        this.paginationSpec.total = res.total;
                        this.paginationSpec.to = res.to;
                    })
                } else {
                    this.optionSpec = [];
                    let data = {
                        id: this.group_id,
                        page: page,
                    }
                    Service.SpecGroup.getSearchGroup(data).then(res => {
                        // console.log(res)
                        res.data.forEach(mainGroup => {
                            this.optionSpec.push({
                                optionSelect: `หมวดหมู่ ${mainGroup.group_main} ${mainGroup.main_group_desc}`,
                                group_main: `${mainGroup.group_main}`,
                                groupNum: `${mainGroup.group_num}`,
                                groupSp: `${mainGroup.group_num}`,
                                subGroup1: mainGroup.sub_group1_desc === null ? '-' : mainGroup.sub_group1_desc,
                                // subGroup1: mainGroup.group_level === "1" ? mainGroup.main_group_desc : mainGroup.sub_group1_desc,
                                subGroup2: mainGroup.sub_group2_desc === null ? '-' : mainGroup.sub_group2_desc,
                                subGroup3: mainGroup.sub_group3_desc === null ? '-' : mainGroup.sub_group3_desc,
                            });
                        })

                        this.paginationSpec.current_page = res.current_page;
                        this.paginationSpec.from = res.from;
                        this.paginationSpec.last_page = res.last_page;
                        this.paginationSpec.per_page = res.per_page;
                        this.paginationSpec.total = res.total;
                        this.paginationSpec.to = res.to;
                    })
                }

            }
        }
    }
</script>

<style lang="scss">
  .tab-2 {
    label.v-label.theme--dark {
      position: unset !important;
    }
    .v-menu__content.theme--light.menuable__content__active {
      text-align: left !important;
    }
  }
  .search-Data-Form {
    label.v-label.theme--dark {
      position: unset!important;
    }
  }

</style>
